/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { Checkbox, Table, Typography } from 'antd'
import { formatCurrency } from '../../utils/currency'
import { LineItem } from '../../types/ffe'
import {
  DraftPurchaseOrderMaterial,
  SupplierOrderItemList
} from './PurchaseOrderDrawer'
import { useCompanyStore } from '../../store/company/companyStore'

const { Text } = Typography

interface Props {
  items: SupplierOrderItemList
  onChangeItemSelection: (index: string, selected: boolean) => void
}

export const OrderItemList: React.FC<Props> = ({
  items,
  onChangeItemSelection
}) => {
  const internalDescriptionVisible = useCompanyStore(
    (state) => state.company.purchaseOrderSettings?.internalDescriptionVisible
  )
  const columns = [
    {
      title: '',
      dataIndex: 'code',
      key: 'code',

      render: (_: unknown, item: SupplierOrderItemList[0]) => (
        <div>
          <Checkbox
            checked={item.selected}
            onChange={(value) =>
              onChangeItemSelection(item.id, value.target.checked)
            }
          />
        </div>
      )
    },
    {
      title: 'Item',
      dataIndex: 'code',
      key: 'code',
      render: (code: string, record: any) => (
        <div>
          {record.supplierItemCode && (
            <Text className="block text-sm">{record.supplierItemCode}</Text>
          )}
          {internalDescriptionVisible && record.internalNotes && (
            <Text className="block text-sm">
              {record.internalNotes}
            </Text>
          )}
          <div>
            <Text type="secondary" className="font-mono text-sm">
              {code}
            </Text>
          </div>
        </div>
      )
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right' as const,
      render: (
        quantity: number,
        record: LineItem | DraftPurchaseOrderMaterial
      ) => {
        if ('unit' in record) {
          return (
            <Text>
              {quantity} {record.unit}
            </Text>
          )
        } else {
          return quantity
        }
      }
    },
    {
      title: 'Unit Price',
      dataIndex: 'costPrice',
      key: 'costPrice',
      align: 'right' as const,
      render: (price: number) => formatCurrency(price)
    },
    {
      title: 'Total',
      key: 'total',
      align: 'right' as const,
      render: (_: any, record: any) =>
        formatCurrency(record.quantity * record.costPrice)
    }
  ]

  const data = [
    ...items.map((item) =>
      item.type === 'lineItem'
        ? { ...item, key: item.id }
        : {
            ...item,
            key: item.id + item.lineItem.id,
            code: item.lineItem.code + ` - ${item.materialType === 'finish' ? 'Finish' : 'Accessory'}`,
            supplierItemCode: item.supplierItemCode || item.name,
            costPrice: item.costPerUnit,
            description: `Material (${item.unit})`
          }
    )
  ]

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      size="small"
    />
  )
}
